<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" title="Өндөрлөөгүй" />
    </div>
    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <ReportEndDayTable
        :loading="isLoading"
        :rows="reportLoanList"
        :columns="columns"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        :custom-filters="customFilters"
        :is-loading-change-status="isLoadingChangeStatus"
        :is-loading-re-change-status="isLoadingReChangeStatus"
        :changing-item-id="endDayChangeId"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
        @onChangeCustomFilter="onChangeCustomFilter"
        @onChange="onChange"
        @onReChange="onReChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  REPORT_END_DAY_REQUEST,
  END_DAY_CHANGE_STATUS,
  END_DAY_RE_CHANGE_STATUS,
} from '@/store/actions/report';
import PageHeader from '@/components/ui/PageHeader';
import ReportEndDayTable from '@/components/report/ReportEndDayTable';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  components: {
    PageHeader,
    ReportEndDayTable,
  },

  data() {
    return {
      storeActionListRequest: REPORT_END_DAY_REQUEST,
      columns: [
        // bank
        { label: this.$t('table.date'), field: 'endDate' },
        { label: 'Олголт', field: 'bankExpense' },
        { label: 'Шимтгэл', field: 'feeIncome' },
        { label: 'Төлөлт', field: 'bankIncome' },
        { label: 'Олголт тоо', field: 'bankExpenseCount' },
        { label: 'Төлөлт тоо', field: 'bankIncomeCount' },
        // system
        { label: 'Олголт', field: 'totalLoanIssuedAmount' },
        { label: 'Төлөлт', field: 'totalLoanPaidAmount' },
        { label: 'Олголт тоо', field: 'totalLoanIssuedCount' },
        { label: 'Төлөлт тоо', field: 'totalLoanPaidCount' },
        { label: 'Статус', field: 'statusText' },
        {
          label: this.$t('table.action'),
          field: 'action',
        },
      ],
      customFilters: [],
    };
  },

  computed: {
    ...mapGetters([
      'reportLoanList',
      'reportLoanListStatus',
      'reportLoanListMeta',
      'endDayChangeId',
      'endDayChangeStatus',
      'endDayReChangeStatus',
    ]),
    isLoading() {
      return this.reportLoanListStatus === 'loading';
    },
    isLoadingChangeStatus() {
      return this.endDayChangeStatus === 'loading';
    },
    isLoadingReChangeStatus() {
      return this.endDayReChangeStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters['filter[status]'] = false;
      this.customFilters.forEach(item => {
        data.filters[`filter[${item.key}]`] = item.value;
      });
    },
    setPaginationValues() {
      this.totalRecords = this.reportLoanListMeta ? this.reportLoanListMeta.total : 1;
      this.page = this.reportLoanListMeta.currentPage;
      this.totalPage = this.reportLoanListMeta.lastPage;
    },
    onChangeCustomFilter(object) {
      const index = this.customFilters.findIndex(item => item.key === object.key);
      if (index > -1) {
        const { value } = object;
        this.customFilters[index].value = value || null;
        this.page = 1;
        this.fetchData();
      }
    },
    async onChange(id) {
      try {
        await this.$store.dispatch(END_DAY_CHANGE_STATUS, id);
        if (this.endDayChangeStatus === 'success') {
          this.$router.push({ name: 'ReportEndDayCompleted' });
        }
      } catch (error) {
        // console.error(error)
      }
    },
    async onReChange(id) {
      try {
        await this.$store.dispatch(END_DAY_RE_CHANGE_STATUS, id);
        if (this.endDayReChangeStatus === 'success') {
          this.fetchData();
          this.$toasted.show(this.$t('toast.success'), { type: 'success' });
        }
      } catch (error) {
        // console.error(error)
      }
    },
  },
};
</script>
